import { dataFormatter } from "./admin";
import Cookies from "js-cookie";
import {
  convertToCamelCase,
  convertToSnakeCase,
} from "../redux/actions/helpers";
import axios from "axios";

export const loadInvites = async (page) => {
  const response = await axios
    .get(`/api/v1/invites?page=${page}`, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });

  if (response.status === 200) {
    const meta = JSON.parse(response.request.response)["meta"];
    const results = dataFormatter.deserialize(response.data).map((obj) => {
      return convertToCamelCase(obj);
    });

    return { results: results, meta: meta };
  }
};

export const createInvite = async (formData) => {
  const response = await axios
    .post(
      "/api/v1/invites",
      {
        data: { attributes: convertToSnakeCase(formData) },
      },
      {
        headers: {
          Authorization: `Bearer ${
            Cookies.get("jwt") || localStorage.getItem("jwt")
          }`,
        },
      }
    )
    .catch((error) => {
      throw error;
    });

  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};

export const destroyInvite = async (id) => {
  const response = await axios
    .delete(`/api/v1/invites/${id}`, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });
  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};

export const resendInvite = async (id) => {
  const response = await axios
    .post(
      `/api/v1/invites/${id}/resend_invite`,
      {},
      {
        headers: {
          Authorization: `Bearer ${
            Cookies.get("jwt") || localStorage.getItem("jwt")
          }`,
        },
      }
    )
    .catch((error) => {
      throw error;
    });
  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};
